import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const fetchCategories = (url: string, params: unknown = {}) =>
  axios
    .get(url, { params })
    .then(({ data }) =>
      data.map((c: { id: number; name: string }) => ({
        name: `cat_${c.id}`,
        label: c.name,
        query: {
          [`cat_${c.id}`]: c.id,
        },
      })),
    )
    .catch((error) => {
      // Prevent double error notifications when user is not authorized
      if (error?.response?.status !== 403) {
        displayXhrError(error);
      }
    });
